import React, {useState}  from 'react';
import TableWrapRowsBoot from './StockItems/TableWrapRowsBoot';
import NormalIcon from './StockItems/NormalIcon';
import NormalBtn from './StockItems/NormalBtn';
import * as CoreFns from './utilities/CoreFns';

function App(props) {

  var urlParamsForPreview = props.urlParamsForPreview;
  var setUrlParamsForPreview = props.setUrlParamsForPreview;


  const [focusOn, setFocusOn] = useState(false);
  const [testAnswer, setTestAnswer] = useState('');

  function deleteParameter(parameterI) {
    return function(e) {
      var newPSet = [];
      for (var i = 0; i < urlParamsForPreview.length; i++){
        if (urlParamsForPreview[i].i === parameterI){
        }else{
          newPSet.push(urlParamsForPreview[i]);
        }
      }
      setUrlParamsForPreview(newPSet);
    }
  }

  function editParameter(row){
    return function(e){
      setTestAnswer(row.t);
      setFocusOn(row.i);
      e.stopPropagation();
    }
  }

    function onInputKeyDown(e){
      if (e.keyCode === 13){
        for (var i = 0; i < urlParamsForPreview.length; i++){
          if (urlParamsForPreview[i].i === focusOn){
            urlParamsForPreview[i].t = testAnswer;
          }
        }
        setUrlParamsForPreview(urlParamsForPreview);
        setFocusOn(false);
      }
    }  

  function onChange(e){
    setTestAnswer(e.target.value);
    e.stopPropagation();
  }
//
    var topUpRows = urlParamsForPreview.map((aRow, index)=>{

      var paraValue;
      if (aRow.i === focusOn){
        paraValue = <td><input autoFocus className='inputBoxClassLong' value={testAnswer} onChange={onChange} style={{width:'80%'}} placeholder='Enter Paramter Value' onKeyDown={onInputKeyDown}/></td>
      }else{
        paraValue = <td>{aRow.t} <NormalIcon icon='akar-icons:edit' title='Edit' height='30px' onClick = {editParameter(aRow)} /></td>
      }

        return <tr key={index}><td>{aRow.i}</td>
              {paraValue}
              <td><NormalIcon icon='fe:trash' title='Delete' height='30px' onClick={deleteParameter(aRow.i)} /></td>
            </tr>
      })

                 
  function addUrlParam(e){
    var p = window.prompt('What would you like the parameter to be called?');
    if (p){
      var subP = p.toLowerCase();
      for (var i = 0 ; i < urlParamsForPreview.length; i++){
        if (urlParamsForPreview[i].i === subP){
          window.alert('Repeated paramters not allowed');
        }
      }
      urlParamsForPreview.push({i:subP, t:''});
      setUrlParamsForPreview([...urlParamsForPreview]);
      setFocusOn(subP)
      setTestAnswer('');
    }
  }

  var param = CoreFns.paramLine(urlParamsForPreview);
  var paramText;
  if (param){
    paramText = 'URL simulated : https://www.cues.sg/dapps/XXXXX/' + param;
  }else{
    paramText = 'URL simulated : https://www.cues.sg/dapps/XXXXX/';
  }

  return <center><div className='container-fluid py-5' style={{backgroundColor:'white'}}><div className='row'><div className='col-12 mx-auto text-center'>
          <p className='lead mb-0'>{paramText}</p><br/>
          <TableWrapRowsBoot rows={topUpRows} headerCells={['Parameter', 'Value', '']}/>
          <br/>
            <NormalBtn onClick={addUrlParam} title='Add URL Parameter'/>
            
   </div></div></div></center>

}

export default App;
